
/**
 * @module date-utils
 * @name formatDateAsYYMMDD
 *
 * @param {Date} date date to be formatted
 * @returns {string}
 *
 * @description
 * Formats the date as YYMMDD string.
 */
export function formatDateAsYYMMDD(date: Date): string {
    const dd = date.getDate().toString().padStart(2,'0');
    const mm = (date.getMonth() + 1).toString().padStart(2,'0');
    const yy = date.getFullYear().toString().slice(-2);
    return `${yy}${mm}${dd}`;
}

/**
 * @module date-utils
 * @name formatDateAsYYYY
 *
 * @param {Date} date date to be formatted
 * @returns {string}
 *
 * @description
 * Formats year from the date as YYYY string.
 */
export function formatDateAsYYYY(date: Date): string {
    return date.getFullYear().toString().padStart(4, '0');
}